'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

require('./RichMediaPreviewOverlay.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var RichMediaPreviewOverlay = function RichMediaPreviewOverlay(_ref) {
    var onClick = _ref.onClick,
        show = _ref.show,
        _ref$iconName = _ref.iconName,
        iconName = _ref$iconName === undefined ? 'play-arrow' : _ref$iconName;

    if (!show) return null;

    return _react2.default.createElement(
        'div',
        { className: 'RichMediaPreviewOverlay' },
        _react2.default.createElement(
            'div',
            { className: 'circle-hit-area', onClick: onClick },
            _react2.default.createElement(
                'div',
                { className: 'circle' },
                _react2.default.createElement(_Icon2.default, { name: iconName })
            )
        )
    );
};

// Styles


RichMediaPreviewOverlay.propTypes = {
    onClick: _propTypes2.default.func,
    show: _propTypes2.default.bool,
    iconName: _propTypes2.default.string
};

exports.default = RichMediaPreviewOverlay;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/richMedia/components/RichMediaPreviewOverlay.js
// module id = 2013
// module chunks = 0